import React from 'react'
import styled from "./SideDiv1.module.css"
const SideDiv6 = () => {
  return (
    <div style={{textAlign:"left"}} className={styled.div1}>
       <h3>Services for Recruiters</h3>
       <h4>Naukri Employer Zone</h4>
       <p>End your hunt for the perfect employee</p>
       <h4>Search CVs for Free now</h4>
       <p>Find the right candidate</p>
       <h4>Naukri Job Posting Services and Resume Database Access</h4>
       <p>Call 1800-102-2558 for Employer products</p>
       <h4>Campus Hiring Solutions</h4>
       <p>Optimize your Fresher Hiring</p>
       <h4>Naukri RMS</h4>
       <p>Automate your end to end hiring process</p>

       </div>
  )
}

export default SideDiv6
